var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "currentColor",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.585 18.974-4.301-3.564c-1.186-.988-.521-2.841.962-2.955h.003l5.62-.414c.055-.004.082-.035.089-.052l.003-.007 2.347-5.59h.112c.785-.867 2.326-.704 2.827.49l2.144 5.107c.007.017.033.048.087.052l5.625.414c1.483.114 2.148 1.967.962 2.955l-.001.001-4.309 3.578a.046.046 0 0 0-.015.023.08.08 0 0 0 0 .044l1.34 5.358c.37 1.5-1.284 2.588-2.536 1.833l-4.804-2.894-.004-.002a.115.115 0 0 0-.114 0l-.004.002-4.805 2.894c-1.251.755-2.906-.332-2.535-1.833v-.002l1.34-5.356a.059.059 0 0 0-.001-.034.12.12 0 0 0-.032-.048Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.053 36.037c1.505 0 2.915.402 4.13 1.105V26.77l2.42-1.457.005-.004a.146.146 0 0 1 .144 0l.006.004 1.555.936v18.564h-.016a8.26 8.26 0 1 1-8.244-8.776Zm-4.13 8.26a4.13 4.13 0 1 1 8.26 0 4.13 4.13 0 0 1-8.26 0ZM34.15 27.466l11.778 2.049v7.627a8.26 8.26 0 1 0 4.114 7.67h.016V20.388a3.097 3.097 0 0 0-2.567-3.051l-10.054-1.749-4.174 3.466 12.665 2.203v4.067l-12.717-2.212.89 3.552c.069.281.082.55.05.803Zm3.52 16.83a4.13 4.13 0 1 1 8.258 0 4.13 4.13 0 0 1-8.259 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMusic);
export default __webpack_public_path__ + "static/media/new-music.ce7df065.svg";
export { ForwardRef as ReactComponent };